<template>
  <el-row style="min-height:100%">
      <el-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 12, offset: 6 }"
        :lg="{ span: 8, offset: 8 }"
        style="min-height:100%"
      >
        <router-view />
      </el-col>
    </el-row>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
*{
  box-sizing: border-box;
}
html,body{padding:0;margin:0;font-size:18px}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
